<template>
  <v-card class="base-64-decoder tools-view-card">
    <ToolbarHeader :name="'Base 64 Encode-Decode'"/>
    <v-container>
      <section class="ma-5">
        <v-row align="center"
               justify="center">
          <v-col cols="12"
                 sm="5"
                 md="5">
            <label>
              Decode
            </label>
            <editor
                v-model="decodeForm.decode"
                @init="initTextEditor"
                width="100%"
                height="60vh">
            </editor>
          </v-col>
          <v-col cols="12"
                 sm="2"
                 md="2"
          >
            <v-btn
                @click="handleDecodeForm"
                color="primary"
                class="mt-2 w-100"
            >
              Decode
              <v-icon class="ml-2">mdi-arrow-right</v-icon>
            </v-btn>
            <v-btn
                @click="handleEncodeForm"
                color="primary"
                class="mt-2 w-100"
            >
              Encode
              <v-icon class="ml-2">mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12"
                 sm="5"
                 md="5">

            <label>
              Encode
            </label>
            <editor
                v-model="encodeForm.encode"
                @init="initTextEditor"
                width="100%"
                height="60vh">
            </editor>
          </v-col>
        </v-row>
      </section>
    </v-container>
  </v-card>
</template>
<script>
import {mapGetters} from "vuex";
import ToolbarHeader from "@/components/Toolbar-Header";
import {aceEditorMixin} from "@/mixins/aceEditorMixin";

const encodeForm = {
  encode: ''
};


const decodeForm = {
  decode: 'dGhpcyBpcyBiYXNpYyA2NCBkZWNvZGUgdGV4dCBmb3IgdGVzdGluZwo=',
};


export default {
  name: "Base-64-Encoder-Decoder",
  mixins: [aceEditorMixin],
  components: {
    ToolbarHeader
  },
  computed: {
    ...mapGetters([
      'DECODER',
    ]),
  },
  data: () => ({
    decodeForm: Object.assign({}, decodeForm),
    encodeForm: Object.assign({}, encodeForm)
  }),
  methods: {
    handleDecodeForm() {
      if (!this.decodeForm.decode) {
        return;
      }

      try {
        this.encodeForm.encode = window.atob(this.decodeForm.decode);
      } catch (error) {
        this.$store
            .dispatch('SHOW_SNACKBAR',
                {
                  time: 2000,
                  content: error,
                  color: 'error'
                });
      }
    },
    handleEncodeForm() {
      if (!this.encodeForm.encode) {
        return;
      }

      try {
        this.decodeForm.decode =  window.btoa(this.encodeForm.encode);
      } catch (error) {
        this.$store
            .dispatch('SHOW_SNACKBAR',
                {
                  time: 2000,
                  content: error,
                  color: 'error'
                });
      }
    }
  }
}
</script>

<style scoped>

</style>
